var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label || _vm.remaining !== 'aN:aN')?_c('span',{class:{'text-sans-serif':!_vm.label && _vm.remaining, 'font-weight-400':true}},[_vm._v(_vm._s(_vm.label || _vm.remaining))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }